<template>
  <div class="content">
    <div class="filter f--c">
      <el-select v-model="listParams.categoryNames" multiple collapse-tags clearable size="medium" placeholder="请选择标签" style="width:200px;" @change="e => change(e, 'categoryNames')">
        <el-option v-for="item in typeList" :key="item.categoryName" :label="item.categoryName" :value="item.categoryName" />
      </el-select>
      <el-select v-model="listParams.status" size="medium" clearable placeholder="请选择版型状态" style="width:150px;" @change="e => change(e, 'statusList')">
        <el-option label="在售" :value="1" />
        <el-option label="下架" :value="0" />
        <el-option label="缺货" :value="4" />
      </el-select>
      <div class="select-picker">
        <el-select v-model="listParams.dateType" size="medium" placeholder="请选择" style="width:120px;" @change="onSelectDateType">
          <el-option label="创建时间" :value="1" />
          <el-option label="更新时间" :value="2" />
        </el-select>
        <el-date-picker v-model="listParams.dateTime" size="medium" type="datetimerange" style="width:370px;padding-right:0" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>
      <BatchSearch :option="searchConditionOptins" :selected="listParams.searchType" @select="searchType" @search="search" @clear="searchClear" />
    </div>

    <el-table v-loading="loading" :data="list" height="calc(100vh - 190px)" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column label="版型信息" :min-width="280">
        <div class="table-info f--c" slot-scope="{ row }">
          <el-popover placement="right" width="280" trigger="hover">
            <el-image :src="row.imageUrl" fit="cover" />
            <el-image slot="reference" :src="row.imageUrl" fit="cover" class="img" />
          </el-popover>
          <div class="info-text">
            <el-tooltip class="item" effect="dark" :content="row.enName" placement="top-start">
              <div class="ellipsis">标题: {{ row.enName }}</div>
            </el-tooltip>
            <div>版型编号: {{ row.modelCode }}</div>
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="status" label="版型状态" :min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.status" :disabled="row.infoMissing" size="medium" placeholder="请选择" style="width:100px;" @change="handleEdit(row, 'status')">
            <el-option label="在售" :value="1" />
            <el-option label="下架" :value="0" />
            <el-option label="缺货" :value="4" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" label="分类" :min-width="160">
        <template slot-scope="{ row }">
          <!-- <el-input placeholder="请输入分类" v-model="row.categoryName" :disabled="row.firstTimeOnShelves" maxlength="50" style="width:140px" @input="e => handleInput(e, row)" @blur="handleEdit(row, 'categoryName')"></el-input> -->
          <el-select v-model="row.categoryName" :disabled="row.firstTimeOnShelves" size="medium" placeholder="请选择版型分类" style="width:140px;" @change="handleEdit(row, 'categoryName')">
            <el-option v-for="item in typeList" :key="item.categoryName" :label="item.categoryName" :value="item.categoryName" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="sizeContent" label="尺码" :min-width="180"></el-table-column>
      <el-table-column prop="cost" label="开发建议价（￥）" :min-width="140"></el-table-column>
      <el-table-column prop="kkCost" label="成本价（$）" :min-width="110"></el-table-column>
      <el-table-column prop="price" label="售价（$）" :min-width="110"></el-table-column>
      <el-table-column prop="weight" label="重量（g）" :min-width="110"></el-table-column>
      <el-table-column prop="designPlatformCode" label="供应商" :min-width="110"></el-table-column>
      <el-table-column label="创建时间/更新时间" :width="220">
        <template slot-scope="{ row }">
          <div>创建时间:{{ row.createDate | dateFormat}}</div>
          <div>更新时间:{{ row.modifyDate | dateFormat}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="100">
        <template slot-scope="{ row }">
          <el-button type="text" @click="editInfo(row)" style="margin-right: 10px;">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 12px">
      <div>
        <el-dropdown :disabled="!selection.length" @command="(e) => handleCommand(e)" trigger="click">
          <el-button type="primary">
            批量操作
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="status">修改状态</el-dropdown-item>
            <el-dropdown-item command="categoryName">修改分类</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <batch-set ref="batchSet" :categoryNames="typeList" @setSuccess="setSuccess('batch')" />
    <set-info ref="setInfo" :categoryNames="typeList" @setSuccess="setSuccess('edit')" />
  </div>
</template>

<script>
import BatchSearch from '@/components/BatchSearch.vue'
import BatchSet from './components/batchSet.vue'
import API from '@/api'
import SetInfo from './components/setInfo.vue'

export default {
  name: 'supply_podModel',
  components: {
    BatchSearch,
    BatchSet,
    SetInfo
  },
  data() {
    return {
      loading: false,
      typeList: [],
      list: [],
      listParams: {
        pageSize: 20,
        pageNumber: 1,
        dateType: 1,
        searchType: 1
      },
      total: 0,
      selection: [], // 选中的元素对象

      // 根据条件类型搜索下拉选项
      searchConditionOptins: [
        { label: '版型编号', value: 1 },
        { label: '商品名称', value: 2 }
      ]
    }
  },
  created() {
    this.getModelCategoryNames()
    this.getList()
  },
  mounted() {},
  methods: {
    // 获取版型所有品类名称
    getModelCategoryNames() {
      API.getModelCategoryNames({ status: '0,1,4' }).then(res => {
        this.typeList = res.data
      })
    },
    // 获取列表
    getList() {
      API.getCustomModelList(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.list = res.data.list.map(t => ({ ...t, originalCategoryName: t.categoryName }))
        this.total = res.data.total
      })
    },

    // 切换
    change(e, type) {
      let value;
      if (Array.isArray(e)) {
        value = e
      } else if (e || e === 0) {
        value = [e]
      } else {
        value = undefined
      }
      this.listParams[type] = value
      this.handleCurrentChange(1)
    },

    /**
     * 选择日期筛选类型
     *
     * @param {Number} value 当前选中的类型
     */
    onSelectDateType(value) {
      if (this.listParams.dateTime) {
        // // 付款时间
        if (value === 1) {
          this.listParams.createDateStart = this.listParams.dateTime[0]
          this.listParams.createDateEnd = this.listParams.dateTime[1]
          this.listParams.modifyDateStart = undefined
          this.listParams.modifyDateEnd = undefined
        }
        // 创建时间
        if (value === 2) {
          this.listParams.modifyDateStart = this.listParams.dateTime[0]
          this.listParams.modifyDateEnd = this.listParams.dateTime[1]
          this.listParams.createDateStart = undefined
          this.listParams.createDateEnd = undefined
        }
        this.handleCurrentChange(1)
      }
    },
    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        // 创建时间
        if (this.listParams.dateType === 1) {
          this.listParams.createDateStart = date[0]
          this.listParams.createDateEnd = date[1]
          this.listParams.modifyDateStart = undefined
          this.listParams.modifyDateEnd = undefined
        }
        // 更新时间
        if (this.listParams.dateType === 2) {
          this.listParams.modifyDateStart = date[0]
          this.listParams.modifyDateEnd = date[1]
          this.listParams.createDateStart = undefined
          this.listParams.createDateEnd = undefined
        }
      } else {
        this.listParams.createDateStart = undefined
        this.listParams.createDateEnd = undefined
        this.listParams.modifyDateStart = undefined
        this.listParams.modifyDateEnd = undefined
      }
      this.handleCurrentChange(1)
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    searchType(value) {
      this.listParams.searchType = value
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    search(value) {
      // 版型编号
      if (this.listParams.searchType === 1) {
        this.listParams.modelCodes = value ? value.split(',').map((item) => item.trim()) : []
        this.listParams.enName = undefined
      }
      // 商品名称
      if (this.listParams.searchType === 2) {
        this.listParams.enName = value
        this.listParams.modelCodes = undefined
      }
      this.handleCurrentChange(1)
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    searchClear() {
      this.listParams.modelCodes = undefined
      this.listParams.enName = undefined
      this.handleCurrentChange(1)
    },

    editInfo(row) {
      this.$refs.setInfo.show(row.id)
    },

    handleCommand(command) {
      this.$refs.batchSet.show(command, this.selection)
    },

    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.selection = selection
    },
    handleCurrentChange(page) {
      this.listParams.pageNumber = page || 1
      this.getList()
    },
    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.getList()
    },

    // 批量修改成功
    setSuccess(type) {
      if (type === 'batch') {
        this.selection = []
      }
      this.handleCurrentChange(1)
    },

    handleEdit(row, type) {
      // if (type === 'categoryName' && !row.categoryName) {
      //   this.$set(row, 'categoryName', row.originalCategoryName)
      //   this.$message.warning('分类名称不能为空')
      //   return
      // }
      let param = { ids: [row.id] }
      type === 'categoryName' ? (param.categoryName = row.categoryName) : (param.status = row.status)
      API[type === 'categoryName' ? 'editCustomModelCategoryName' : 'editCustomModelStatus'](param).then(({ code, message }) => {
        if (code !== 10000) return this.$message.error(message)
        this.$message.success('修改成功')
        this.handleCurrentChange(1)
      })
    },
    // 只能输入英文和数字
    handleInput(e, row) {
      this.$set(row, 'categoryName', e.replace(/[^a-zA-Z0-9 ]+/g, '').trim())
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: white;
  min-width: 1200px;
  .filter {
    padding: 12px;
    >div {
      margin-right: 10px;
    }
    .select-picker {
      white-space: nowrap;
    }
  }

  .table-info {
    width: auto;
    .img {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      margin-right: 6px;
    }
    .info-text {
      width: 100%;
    }
  }
  /deep/ .el-dropdown [disabled] {
    color: #fff
  }
}
</style>